// extracted by mini-css-extract-plugin
module.exports = {"label":"watchlist_label__3vG9S","button":"watchlist_button__2LHx8"};